import React, { createContext, useState, useEffect } from "react";

export const ITEContext = createContext();

const defaultFormDataITE = {
  sexe: "",
  nom: "",
  prenom: "",
  adresse: "",
  provinceOuIdf:"",
  ville: "",
  departement: "",
  region: "",
  email: "",
  cp: "",
  tel1: "",
  tel2: "",
  occupationType: "",
  numberOfOccupants: 1,
  constructionYear: 0,
  surfaceAuSol: 0,
  surfaceHabitable: 0,
  hauteurSousPlafond: 0,
  superficieMur: 0,
  nombreMur: "",
  altitude: "",
  numberOfRooms: 1,
  housePosition: "",
  houseShape: "",
  numberOfLevels: "",
  installationType: "",
  protectionType: "",
  ampouleType: "",
  energieType: "",
  sanitaireType: "",
  sourceType: "",
  chauffageType: "",
  chauffagesType: "",
  temperature: 0,
  factureElectricite: 0,
  factureSecondaire: 0,
  revenuFiscal: 0,
  periodeType: "",
  aideColor: "",
  consommationElectrique: 0,
  depenseChauffage: 0,
  depenseECS: 0,
  depenseMenager: 0,
  depenseEclairage: 0,
  baseTemperature: 0,
  solarCoefficient: 0,
  besoinPuissanceChauffage: 0,
  typeDePompeAChaleur: "",
  
  coutProjetITE: 0,
  maPrimeRenovITE: 0,
  aidesCeeITE: 0,
  economies10ansITE: 0,
};

export const ITEProvider = ({ children }) => {
  const [formDataITE, setFormDataITE] = useState(() => {
    const saved = localStorage.getItem("formDataITE");
    return saved ? JSON.parse(saved) : defaultFormDataITE;
  });

  useEffect(() => {
    localStorage.setItem("formDataITE", JSON.stringify(formDataITE));
  }, [formDataITE]);

  return (
    <ITEContext.Provider value={{ formDataITE, setFormDataITE, defaultFormDataITE }}>
      {children}
    </ITEContext.Provider>
  );
}; 